var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAAadministrator(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500061,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#FEFAF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.500061,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "#F7B27A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1987 62H19.7612L35.1235 18.3636H44.882L60.2655 62H51.828L40.1732 27.3125H39.8323L28.1987 62ZM28.4757 44.8906H51.4871V51.2401H28.4757V44.8906Z",
    fill: "#EF6820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAAadministrator);
export default __webpack_public_path__ + "static/media/a-aadministrator.062d3acd815dd00ad26a99e4f925a44a.svg";
export { ForwardRef as ReactComponent };